import React from 'react'
import { Text } from 'grommet';
import { RadiopaediaArticle } from '../RadiopaediaArticle';

export default function RadiopaediaArticleCard(document: RadiopaediaArticle){
    const {description, url, title} = document._source
    return{
            Heading: title,
            Source: url,
            Blurb: (
                <>
                    <Text>{description.substring(0,300)}...</Text>
                </>
            )
    }
}